import { graphql } from 'react-relay';

export const ContentIdByReferenceIdQuery = graphql`
	query ContentIdByReferenceIdQuery($id: String!) {
		contentIdByReferenceId(referenceId: $id)
	}
`;
